import React, { useState } from "react";
import moment from "moment-timezone";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import IconButton from "@material-ui/core/IconButton";
import StaticDispatchMap from "./StaticDispatchMap";
import RightArrowIcon from "@material-ui/icons/ChevronRight";

const OptimizationsViewer = ({ optimizations, userColors, region, setIndex }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!optimizations || optimizations.length === 0) {
    return null;
  }

	const handlePrev = () => {
		setCurrentIndex((prev) => {
			const newIndex = prev === 0 ? optimizations.length - 1 : prev - 1;
			setIndex(newIndex); // fire your secondary state/effect here
			return newIndex;
		});
	};

	const handleNext = () => {
		setCurrentIndex((prev) => {
			const newIndex = prev === optimizations.length - 1 ? 0 : prev + 1;
			setIndex(newIndex); // fire your secondary state/effect here
			return newIndex;
		});
	};

  const total = optimizations.length;
  const current = optimizations[currentIndex];

  return (
    <div
      className="col-6"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <b>Possible Better Routes</b>

      {/* Navigation Controls */}
      <div style={{ display: "flex", alignItems: "center"}}>
	      <IconButton style={{marginRight: 10}}
		      onClick={handlePrev}><LeftArrowIcon/></IconButton>
        <span>
          Option {currentIndex + 1} of {total}
        </span>
	      <IconButton style={{marginLeft: 10}}
		      onClick={handleNext}><RightArrowIcon/></IconButton>
      </div>

      {/* Map */}
      <StaticDispatchMap
        schedule={current.schedule}
        userColors={userColors}
        region={region}
      />
    </div>
  );
};

export default OptimizationsViewer;

